export default __webpack_public_path__ + "static/media/double-chat.b1c4b12d.svg";